import React from "react";

function Note(props) {

    function deleteNote(){
        props.onDelete(props.id)
    }

  return (
    <div className="note">
      <h1>{props.title}</h1>
      <p>{props.content}</p>
      <button className="delButton" style={{ color:"white" }} onClick={deleteNote}>x</button>
    </div>
  );
}

export default Note;
